<template>
  <div id="DashboardRelatorios">

    <div class="text-center centralizado" v-show="modal.load">
      <h3>Pode demorar um pouco...</h3>
      <div class="btn-toolbar d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
        <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
      </div>
    </div>

    <vuestic-widget v-if="modal.show">
      <div class="overflow-mobile">
        <table class="vuetable table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <td>Total: </td>
              <td>{{this.totais.praticas_aceitas}}</td>
              <td>{{this.totais.praticas_analise}}</td>
              <td>{{this.totais.praticas_erro_interno}}</td>
              <td>{{this.totais.praticas_pendentes}}</td>
              <td>{{this.totais.teoricas_aceitas}}</td>
              <td>{{this.totais.teoricas_aguardando}}</td>
              <td>{{this.totais.teoricas_sem_biometria}}</td>
              <td>{{this.totais.teoricas_pendentes}}</td>
              <td></td>
            </tr>
            <tr>
              <th></th>
              <th class="table-secondary rounded" colspan="4">Práticas</th>
              <th class="table-secondary rounded" colspan="4">Teóricas</th>
              <th></th>
            </tr>
            <tr>
              <th class="table-secondary">Auto Escola</th>
              <th class="table-success">Enviadas</th>
              <th class="table-warning">Em Análise</th>
              <th class="table-warning">Erro Interno</th>
              <th class="table-danger">Pendentes</th>
              <th class="table-success">Enviadas</th>
              <th class="table-warning">Pendentes</th>
              <th class="table-warning">Não Possui Biometria</th>
              <th class="table-danger">Rejeitadas</th>
              <th class="table-secondary">Progresso</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="aula in aulas" :key="aula.id">
              <td class="weight">{{aula.autoescola}}</td>
              <td class="green">{{aula.praticas.enviadas}}</td>
              <td class="blue">{{aula.praticas.analise}}</td>
              <td>{{aula.praticas.erro_interno}}</td>
              <td v-if="aula.praticas.pendentes >= 10"><span class="danger">{{aula.praticas.pendentes}}</span></td>
              <td v-else>{{aula.praticas.pendentes}}</td>
              <td class="green">{{aula.teoricas.enviadas}}</td>
              <td class="blue">{{aula.teoricas.aguardando}}</td>
              <td v-if="aula.teoricas.sem_biometria >= 10"><span class="danger">{{aula.teoricas.sem_biometria}}</span></td>
              <td v-else>{{aula.teoricas.sem_biometria}}</td>
              <td v-if="aula.teoricas.pendentes >= 10"><span class="danger">{{aula.teoricas.pendentes}}</span></td>
              <td v-else>{{aula.teoricas.pendentes}}</td>
              <td>
                <div class="progress">
                  <div class="progress-bar" :style="{width: aula.porcentagem + '%'}">{{aula.porcentagem}}%</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </vuestic-widget>

  </div>
</template>

<script>
import urlApi from '../../router/urlApi'
import * as spinners from 'epic-spinners'

export default {

  name: 'dashboard-relatorios',
  components: {
    ...spinners,
  },
  computed: {
  },
  props: {
    foo: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      aulas: [],
      totais: [],
      load: false,
      modal: {
        show: false,
        load: false
      },
    }
  },
  created() {
    this.atualizar();
  },
  methods: {
    atualizar() {
    this.modal.load = true
    this.modal.show = false

    this.$http.get(urlApi + '/aulas/dashboard/aulasPendentesDashboard' + this.$route.path)
      .then(function (response) {
        this.aulas = response.body.aulas.original.dados
        this.totais = response.body.aulas.original.results
        this.modal.show = true
        this.modal.load = false
      })

    setTimeout(this.atualizar, 300000);
    }
  }
}

</script>

<style scoped>

    @media(max-width: 767px) {
      .table td, .table th, .table thead th, .table thead td {
        font-size: 12px !important;
      }

      .overflow-mobile {
        overflow-x: auto;
      }

      .large-table {
        width: auto;
      }
    }

  .rounded {
    border-radius: 1.25rem 1.25rem 0rem 0rem !important;
    background-color: #eceeef;
  }

  .centralizado {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .danger {
    color: red;
    font-weight: 700;
  }

  .table thead tr {
    border-bottom: 0;
    text-transform: uppercase;
    color: #34495e;
  }

  .table-secondary > td {
    background-color: #eceeef;
    border: 0;
  }

  .table-bordered thead th {
    border: 0px;
  }

  th {
    text-align: center;
  }

  td, tr {
    border: 0px;
    font-size: 22px;
    font-weight: 700;
    width: 13px;
    text-align: center;
  }

  .blue {
    color: blue;
  }

  .green {
    color: green
  }

  .white {
    color: white;
  }

  .progress {
    height: 2rem;
    color: #1c2d5a;
  }

</style>
